/**
 * Servicio para consultar la API de sistematización
 */

import apiClient from './api';
import {
  ApiResponse,
  SistematizacionResponse,
  SistematizacionRequest,
  HealthCheckResponse,
  ServicesStatusResponse,
  ProcesarPagoRequest,
  ProcesarPagoResponse,
} from '../types/sistematizacion.types';

class SistematizacionService {
  /**
   * Consulta la sistematización por placa (GET) s
   */
  async consultarPorPlacaGet(
    placa: string,
    captchaToken: string
  ): Promise<ApiResponse<SistematizacionResponse[]>> {
    const response = await apiClient.get<ApiResponse<SistematizacionResponse[]>>(
      `/Sistematizacion/${placa}`,
      {
        headers: {
          'X-Captcha-Token': captchaToken,
        },
      }
    );
    return response.data;
  }

  /**
   * Consulta la sistematización por placa (POST)
   */
  async consultarPorPlacaPost(request: SistematizacionRequest): Promise<ApiResponse<SistematizacionResponse[]>> {
    const response = await apiClient.post<ApiResponse<SistematizacionResponse[]>>(
      '/Sistematizacion/consultar',
      request
    );
    return response.data;
  }

  /**
   * Verifica el estado de salud de la API
   */
  async checkHealth(): Promise<HealthCheckResponse> {
    const response = await apiClient.get<HealthCheckResponse>('/api/Sistematizacion/health');
    return response.data;
  }

  /**
   * Verifica el estado de todos los servicios externos (BD + SAP B1).
   * Se llama al cargar la página para deshabilitar el formulario si hay problemas.
   */
  async checkServicesStatus(): Promise<ApiResponse<ServicesStatusResponse>> {
    const response = await apiClient.get<ApiResponse<ServicesStatusResponse>>(
      '/Sistematizacion/services-status'
    );
    return response.data;
  }

  /**
   * Procesa el pago de sistematización
   */
  async procesarPago(request: ProcesarPagoRequest): Promise<ApiResponse<ProcesarPagoResponse>> {
    const response = await apiClient.post<ApiResponse<ProcesarPagoResponse>>(
      '/Sistematizacion/procesar-pago',
      request
    );
    return response.data;
  }
}

export default new SistematizacionService();
